import { MDText } from 'i18n-react';

import { formatDate } from 'Utilities/formatters';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

import { PriceAndSaleInfo } from '../PriceAndSaleInfo/PriceAndSaleInfo';
import { useHasValuationsToDisplay } from '../Valuations/useHasValuationsToDisplay';
import { Valuations } from '../Valuations/Valuations';

import notYetForSaleTexts from './NotYetForSale.texts';

import styles from './NotYetForSale.module.scss';

const LocalT = new MDText(notYetForSaleTexts);

export const NotYetForSale = () => {
	const hasValuationsToDisplay = useHasValuationsToDisplay();
	const { nextSaleStartsAt } = useSaleTimes();

	return (
		<>
			<PriceAndSaleInfo />
			{hasValuationsToDisplay ? <Valuations /> : null}
			{nextSaleStartsAt ? (
				<div className={styles.liveSaleStartsContainer}>
					<span>{LocalT.translate('liveSaleStarts')}</span>
					<span className={styles.date}>{formatDate(nextSaleStartsAt, 'DD/MM/YY HH:mm')}</span>
				</div>
			) : null}
		</>
	);
};
